<template>
    <v-card class="ma-3 pa-5 show-flex">
        <div v-if="cardType === 'map'">
            <h3>Available variables</h3>
            <v-row class="px-3">
                <p style="margin-top: 20px">
                    All sensor based measurements uses upper sensor last variables (Erk, er). All weather related
                    variables uses corresponding time frame.
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>Averages from the last three measurements: <strong>Erk</strong></p>
            </v-row>
            <v-row class="px-3 variables">
                <p>Last measurement measurement variables: <strong>Er</strong></p>
            </v-row>
            <v-row class="px-3 variables">
                <p>Last measurement weather variables: <strong>air_humidity, precipitation, wind_speed</strong> and <strong>air_temp</strong></p>
            </v-row>
        </div>
        <div v-else-if="cardType === 'dashboard'" class="flex-grow-1">
            <div class="d-flex justify-space-between">
                <h3>Available variables</h3>

                <v-btn class="mt-4" color="primary" small @click="downloadDashboardCSV">
                    Download CSV
                </v-btn>
            </div>
            <v-row class="px-3">
                <p style="margin-top: 20px">
                    Dashboard variables: represent formula target value as <strong>x</strong>
                </p>
            </v-row>
        </div>
        <div v-else-if="cardType === 'no3'" class="flex-grow-1">
            <div class="d-flex justify-space-between">
                <h3>NO3</h3>
            </div>
            <v-row class="px-3">
                <p style="margin-top: 20px">
                    Possible to use in following formula: <strong>AF0</strong> and <strong>salinity</strong>. Can add multiple, code takes first acceptable.
                </p>
            </v-row>
        </div>
        <div v-else>
            <h3>Available variables</h3>
            <v-row class="px-3">
                <p style="margin-top: 20px">
                    Averages from the last three measurements: <strong>Erk, jk, Tmk</strong> and
                    <strong>ECek</strong>
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Averages from the last 24 hour measurements: <strong>avg_24h_ErK, avg_24h_jK, avg_24h_EceK</strong>
                    and
                    <strong>avg_24h_soil_temp</strong><span class="new">New!</span>
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Averages from three measurements average using time label:
                    <strong>Erk-{number_of_days}, jk-{number_of_days}, Tmk-{number_of_days}</strong> and
                    <strong>ECek-{number_of_days}</strong>. Example: Erk-2 gets last three er measurements average from
                    today minus 2 days.
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Averages from three measurements average using offset label:
                    <strong>Erk#{number_of_offset}, jk#{number_of_offset}, Tmk#{number_of_offset}</strong> and
                    <strong>ECek#{number_of_offset}</strong>. Example: Erk gets 12:00, 10:00 and 8:00 measurements then
                    Erk#1 gets 10:00, 8:00 and 6:00. The offset means skipping [number] measurements from last fetch.
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    If you want to add or subtract some variable values, you should mark + or - with spaces. Example:
                    ECek - AF0>100. That is because we use Erk-1, jk-2 etc variables and if you don't wan't to mix them
                    up then it is recommended to use spaces.
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Averages from three measurements average using exact date label:
                    <strong>Erk[YYYY-MM-DD], jk[YYYY-MM-DD], Tmk[YYYY-MM-DD]</strong> and
                    <strong>ECek[YYYY-MM-DD]</strong>. Example: sensor_high.Erk[2025-01-01] return from 2025-01-01
                    00:00:00 first
                    three measurements average. The [YYYY-MM-DD] means specific date in ISO format.<span class="new">New!</span>
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Following variables require either a <strong>sensor_low</strong> or
                    <strong>sensor_high</strong> prefix:
                    <strong>Erk, jk, Tmk, ECek, Erkk, ECekk, AF0, AFVL, avg_24h_soil_temp, avg_24h_ErK, avg_24h_jK,
                        avg_24h_EceK</strong>
                    <span class="new">New!</span>
                    <br/>
                    Example: <strong>sensor_low.Erk > 0</strong> and
                    <strong>sensor_high.ECek-2 > sensor_low.ECek-2</strong>. Both sensors
                    <strong>(sensor_high.Tmk &lt; 10) and (sensor_low.Tmk &lt; 10)</strong>
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Both sensors average from the last three measurements: <strong>Erkk</strong> and
                    <strong>ECekk</strong>
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>This year AF variables: <strong>AF0</strong> and <strong>AFVL</strong></p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Night-time, day-time and 24h avg temp variables: <strong>night_temp_avg</strong>,
                    <strong>day_temp_avg</strong>, <strong>avg_24h_air_temp, 24h_min_temp</strong> and
                    <strong>24h_max_temp</strong>
                </p>
            </v-row>
            <v-row class="px-3 variables">
                <p>Last measurement from air sensor: <strong>current_temp</strong></p>
            </v-row>
            <v-row class="px-3 variables">
                <p>
                    Last measurement weather variables: <strong>wind_speed</strong> and
                    <strong>night_lowest_temp</strong>
                </p>
            </v-row>
        </div>
        <div v-if="cardType === 'recommendations'" class="d-flex">
            <v-btn class="mt-4 mr-2" @click="downloadRecommendedCalculationsCSV" small color="primary"
            >Download CSV
            </v-btn
            >
            <v-btn class="mt-4" @click="testEmail" small color="primary">Send email</v-btn>
        </div>
    </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import FormulaTableService from '@/service/FormulaTableService';
import CalculationTableService from '@/service/CalculationTableService';

export default {
    name: 'CreateVariablesCard',
    props: {
        cardType: {
            default: 'recommendations',
        },
    },
    data() {
        return {
            Er: null,
            j: null,
            Tm: null,
            avg24HoursSensorTemp: null,
        };
    },
    computed: {
        ...mapState('culture', ['newCulture']),
    },
    methods: {
        ...mapActions('culture', ['handleNewCultureClick']),
        ...mapActions('culture', ['fetchCulture']),
        ...mapActions('calculation', ['sendRecommendationEmail']),
        async createNewCulture() {
            if (!this.newCulture.code) {
                return alert('Please fill Index field!');
            }
            await this.handleNewCultureClick();
        },
        async testEmail() {
            await this.sendRecommendationEmail();
        },

        async downloadDashboardCSV() {
            const resp = await FormulaTableService.downloadFormulasCSV();
            const url = window.URL.createObjectURL(new Blob([resp.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'dashboard.csv');
            document.body.appendChild(link);
            link.click();
        },

        async downloadRecommendedCalculationsCSV() {
            const resp = await CalculationTableService.downloadCalculationsCSV();
            const url = window.URL.createObjectURL(new Blob([resp.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'formula.csv');
            document.body.appendChild(link);
            link.click();
        },
    },
    watch: {
        newCulture: function() {
            if (Object.keys(this.newCulture).length === 0) this.fetchCulture();
        },
    },
};
</script>

<style scoped>
.variables {
    margin-top: 0 !important;
}

.show-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.new {
    font-size: 16px;
    font-weight: bold;
    color: red;
    padding-left: 10px;
}

.test {
    border-width: 1px;
    border-style: solid;
    border-color: red;
}
</style>
